import Layout from '@/layout'
export default [
    {
        path: '/account-management',
        component: Layout,
        children: [
            {
                path: '/accountManagement',
                name: 'Account Management',
                component: () => import('@/views/account-management/index'),
                meta: { title: 'Account Management', icon: 'form', adminRequire: true },
                adminOnly: true,
            }
        ]
    },
]